import {useTrans} from '@ui/i18n/use-trans';
import {message} from '@ui/i18n/message';
import {Album} from '@app/web-player/albums/album';
import clsx from 'clsx';
import {AlbumIcon} from '@ui/icons/material/Album';
import {getAlbumImageSrc} from '@app/web-player/media-image/media-image';

interface AlbumImageProps {
  album: Album;
  className?: string;
  size?: string;
  contentFormat?: string;
}
export function AlbumImage({
  album,
  className,
  size,
  contentFormat,
}: AlbumImageProps) {
  const {trans} = useTrans();
  const src = getAlbumImageSrc(album, contentFormat);
  const imgClassName = clsx(
    className,
    size,
    'object-cover bg-fg-base/4',
    !src ? 'flex items-center justify-center' : 'block',
  );

  return src ? (
    <img
      className={imgClassName}
      draggable={false}
      loading="lazy"
      src={src}
      alt={trans(message('Image for :name', {values: {name: album.name}}))}
    />
  ) : (
    <span className={clsx(imgClassName, 'overflow-hidden')}>
      <AlbumIcon className="max-w-[60%] text-divider" size="text-9xl" />
    </span>
  );
}
